<div class="fonts">
        <div class="container-fluid overall-margin">
                <div class="main-section mt-5">
                        <div id='included_page' class="form-outer-div">
                                <div class="form-group-div1">
                                        <span>
                                                <ng-select placeholder="--Select ERG--" class="custom" [items]="ergData"
                                                bindLabel="bpgName" [(ngModel)]="ergId" bindValue="bpgId"
                                                (change)="bpgChange($event)"></ng-select>
                                        </span>
                                </div>
                
                                <div class="form-group-div">
                                        <div>
                                               <ng-select placeholder="--Select SITE--" class="custom" [items]="siteData"
                                                bindLabel="siteName" bindValue="siteId" [(ngModel)]="siteId"
                                                (change)="siteChange($event)"></ng-select>
                                        </div>
                                </div>
                
                                <div id="searchSecn">
                                        <button type="button" class="btn btn-danger" (click)="searchChapter()">Search</button>
                                </div>
                        </div>
                </div>
                <!-- download events>=current data and <= current fiscal year -->
                <!-- <div>
                       <a (click)="printEvents()"> Click here to download</a>
                </div> -->
                <!-- for upcoming events and chapter amount -->
                <div class="col-md-12 col-xs-12 col-sm-12 p-0 mt-5" style="display:inline-flex;">
                        <div class="col-6 p-0">
                                <div class="mb-5 heading">Membership Count</div>
                                <div class="col-12 p-0" style="display:inline-flex;">
                                        <div class="col-5 p-0 mt-2 pt-1">
                                                <div class="col-12 mb-3 p-0">
                                                        <label class="col-2 p-0">As of </label>
                                                        <label class="col-10 color" style="font-weight: bolder;">{{today | date:'MM/dd/yyyy'}}</label>
                                                </div>
                                                <div class="col-12 mb-3 p-0">
                                                        <label class="col-6 p-0">Regular Members</label>
                                                        <label class="col-6 color" style="font-weight: bolder;">{{this.virtualMembershipCount}}</label>
                                                </div>
                                                <div class="col-12 mb-3 p-0">
                                                        <label class="col-6 p-0">Virtual Members</label>
                                                        <label class="col-6 color" style="font-weight: bolder;">{{this.regularMembershipCount}}</label>
                                                </div>
                                        </div>
                                        <div class="col-6 ml-2">
                                                <div id="membershipGraph" style="height: 10rem;"></div>
                                        </div>
                                </div>
                        </div>
                        <div class="col-6 p-0">
                                <div class="mb-5">
                                        <span class="heading">Chapter Budget</span> 
                                        <span class="pl-4 fySelection" [ngClass]="{color : currFySelected}" (click)="updateBudgetData(currentFiscalYear)">{{currentFiscalYearString}}</span>
                                        <span class="pl-4 fySelection" [ngClass]="{color : !currFySelected}" (click)="updateBudgetData(prevFiscalYear)">{{prevFiscalYearString}}</span>
                                </div>
                                <div class="col-12 p-0" style="display:inline-flex;">
                                        <div class="col-6 p-0 mt-2 pt-1">
                                                <div class="col-12 mb-3 p-0">
                                                        <label class="col-5 p-0">Total Budget</label>
                                                        <label *ngIf="currFySelected" class="col-7 color" style="font-weight: bolder;">{{currentFyTotalChapterBudget|currency}}</label>
                                                        <label *ngIf="!currFySelected" class="col-7 color" style="font-weight: bolder;">{{prevFyTotalChapterBudget|currency}}</label>
                                                </div>
                                                <div class="col-12 mb-3 p-0">
                                                        <label class="col-5 p-0">Claimed Budget</label>
                                                        <label *ngIf="currFySelected" class="col-7 color" style="font-weight: bolder;">{{currentFyClaimedChapterBudget|currency}}</label>
                                                        <label *ngIf="!currFySelected" class="col-7 color" style="font-weight: bolder;">{{prevFyClaimedchapterBudget|currency}}</label>
                                                </div>
                                                <div class="col-12 p-0">
                                                        <label class="col-5 p-0">Available Budget</label>
                                                        <label *ngIf="currFySelected" class="col-7 color" style="font-weight: bolder;">{{currentFyAvailableChapterBudget|currency}}</label>
                                                        <label *ngIf="!currFySelected" class="col-7 color" style="font-weight: bolder;">{{prevFyAvailableChapterBudget|currency}}</label>
                                                </div>
                                        </div>
                                        <div class="col-6 ml-2">
                                                <div id="budgetGraph" style="height: 10rem;"></div>
                                        </div>
                                </div>
                        </div>
                </div>
                <!-- for upcoming budgets and membership -->
                <!-- <div class="col-md-12 col-xs-12 col-sm-12 mt-5 p-0 mb-5" style="display:inline-flex">
                        <div class="col-6 p-0">
                                <div class="mb-5 heading">Upcoming Events
                                        <mat-icon class="rotated-arrow" [routerLink]="['/events']">arrow_forward</mat-icon>
                                </div>
                                <div *ngFor="let event of eventsData">
                                        <div class="mt-4 mb-4"><input type="checkbox">
                                                <span class="label-text "></span><span class="color pr-4 pl-5">{{ event.eventCreateDate |
                                                        date:'MMM d' }}
                                                </span><span (click)="redirectToEvent(event.eventId)">{{event.eventName}}</span>
                                        </div>
                                </div>
                        </div>
                        <div class="col-6 p-0">
                                <div class="mb-5 heading">Active Budget Requests
                                        <mat-icon class="rotated-arrow" [routerLink]="['/expense-list']">arrow_forward</mat-icon></div>
                                <div *ngFor="let budget of budgetData">
                                        <div class="col-12 mb-3 p-0">
                                                <label class="col-1 p-0">
                                                        <input type="checkbox">
                                                        <span class="label-text "></span>
                                                </label>
                                                <label (click)="redirectToExpense(budget.expenseId,budget.expenseStatus)" style="word-wrap: break-word;" class="col-5 p-0">{{budget.expenseName}}</label>
                                                <label class="col-3 color" style="font-weight: bolder;">{{budget.totalExpense | currency}}</label>
                                                <label class="col-3 color" style="font-weight: bolder;">{{budget.expenseStatus}}</label>
                                        </div>
                                </div>
                        </div>
                </div> -->
        </div>

        <!-- for printing -->
                <!-- <div id="printEvents" [hidden]="true">
                        <div *ngFor="let events of eventList; let i=index">
                               <div class="text-center mt-5 mb-5" *ngIf="i==0">
                                  <h2>Events of {{events.siteName}} - {{events.bpgName}} for {{currentFiscalYear}}</h2>
                               </div>
                        <div class="m-3 event-list event-list-outerdiv">
                                <div class="date_span">
                                        <span class="date-style">{{events.eventDay}}</span><br>
                                        <span class="month-style">{{events.eventMonth}}</span>
                                </div>
                                <div class="events_info">
                                        <span class="filteredBpg">{{events.siteName}}</span><span
                                                class="colon-padding filteredBpg">-</span><span
                                                class="filteredBpg">{{events.bpgName}}</span><span class="colon-padding filteredBpg"> -
                                        </span><span class="event-name-span">{{events.eventName}}</span>
                                        <div class="event-time-loc">
                                                <span class="common-line-height">{{events.startTime}}</span> to
                                                <span>{{events.endTime}}</span><span> {{events.timeZone}} </span><span
                                                        class="common-line-height"><span
                                                                class="pipe-padding">|</span>{{events.venue}}</span><br>
                                                <div class="view-details-align">
                                                        <span class="common-line-height">{{events.bpgName}}<span
                                                                        class="common-line-height"></span></span>
                                                </div>
                                        </div>
                                </div>
                        </div>
                        </div>
                </div> -->

       
</div>